import { useContext } from "react";

import { GeoReferencerContext } from "./GeoReferencerContext";
import { GeoReferencerContextValue } from "./types";

export function useGeoReferencer(): GeoReferencerContextValue {
  const context = useContext(GeoReferencerContext);
  if (!context) {
    throw new Error("useGeoReferencer must be used within a GeoReferencerProvider");
  }
  return context;
}
